// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__U4-Up","itemTitle":"ClientEmergencyInfo_itemTitle__wQmCN","itemText":"ClientEmergencyInfo_itemText__78KoO"};